"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Logger_1 = require("../Logger");
var Utilities_1 = require("../Utilities");
var qwest = require("qwest");
qwest.setDefaultOptions({
    responseType: 'json',
    dataType: 'json'
});
var ServiceHandler = (function () {
    function ServiceHandler(serviceBasePath) {
        if (typeof serviceBasePath === 'undefined') {
            csod.logger.warn('Service handler was instantiated without a base path. Service calls using this handler might fail.');
            this._basePath = '';
        }
        else
            this._basePath = serviceBasePath;
    }
    ServiceHandler.prototype._calculateURL = function (url) {
        var url = this._basePath + url;
        if (csod.context.debug) {
            if (url.indexOf('?') == -1)
                url += '?debug=true';
            else
                url += '&debug=true';
        }
        return url;
    };
    ServiceHandler.prototype.get = function (url, options, isXhr, before) {
        url = this._calculateURL(url);
        var message = ServiceHandler.begin_trace(url, 'GET');
        return qwest.get(url, null, ServiceHandler.setAuthHeader(options), before)
            .then(function (response) { return ServiceHandler.handleSuccessRes(response, message, isXhr); })
            .catch(function (e, xhr, response) { return ServiceHandler.handleErrorRes(e, xhr, response, message); });
    };
    ServiceHandler.prototype.post = function (url, data, options, isXhr, before) {
        url = this._calculateURL(url);
        var message = ServiceHandler.begin_trace(url, 'POST');
        return qwest.post(url, data, ServiceHandler.setAuthHeader(options), before)
            .then(function (response) { return ServiceHandler.handleSuccessRes(response, message, isXhr); })
            .catch(function (e, xhr, response) { return ServiceHandler.handleErrorRes(e, xhr, response, message); });
    };
    ServiceHandler.prototype.put = function (url, data, options, isXhr, before) {
        url = this._calculateURL(url);
        var message = ServiceHandler.begin_trace(url, 'PUT');
        return qwest.put(url, data, ServiceHandler.setAuthHeader(options), before)
            .then(function (response) { return ServiceHandler.handleSuccessRes(response, message, isXhr); })
            .catch(function (e, xhr, response) { return ServiceHandler.handleErrorRes(e, xhr, response, message); });
    };
    ServiceHandler.prototype.delete = function (url, options, isXhr, before) {
        url = this._calculateURL(url);
        var message = ServiceHandler.begin_trace(url, 'DELETE');
        return qwest.delete(url, null, ServiceHandler.setAuthHeader(options), before)
            .then(function (response) { return ServiceHandler.handleSuccessRes(response, message, isXhr); })
            .catch(function (e, xhr, response) { return ServiceHandler.handleErrorRes(e, xhr, response, message); });
    };
    ServiceHandler.prototype.batchDelete = function (url, data, options, isXhr, before) {
        url = this._calculateURL(url);
        var message = ServiceHandler.begin_trace(url, 'BATCH DELETE');
        return qwest.delete(url, data, ServiceHandler.setAuthHeader(options), before)
            .then(function (response) { return ServiceHandler.handleSuccessRes(response, message, isXhr); })
            .catch(function (e, xhr, response) { return ServiceHandler.handleErrorRes(e, xhr, response, message); });
    };
    ServiceHandler.prototype.patch = function (url, data, options, isXhr, before) {
        url = this._calculateURL(url);
        var message = ServiceHandler.begin_trace(url, 'PATCH');
        return qwest.map('PATCH', url, data, ServiceHandler.setAuthHeader(options), before)
            .then(function (response) { return ServiceHandler.handleSuccessRes(response, message, isXhr); })
            .catch(function (e, xhr, response) { return ServiceHandler.handleErrorRes(e, xhr, response, message); });
    };
    ServiceHandler.parseResponse = function (response) {
        if (typeof response.response === 'object') {
            return response.response;
        }
        else {
            return JSON.parse(response.response);
        }
    };
    ServiceHandler.parseXhrResponse = function (xhr) {
        return ServiceHandler.parseResponse(xhr);
    };
    ServiceHandler.begin_trace = function (url, method) {
        if (csod.context.log && csod.context.log.level !== 'off') {
            var message = new Logger_1.XHRTraceMessage();
            message.data = {
                method: method,
                url: url,
                size: 0
            };
            csod.logger.debug(message);
            return message;
        }
    };
    ServiceHandler.handleSuccessRes = function (response, message, isXhr) {
        if (csod.context.log.level !== 'off') {
            csod.logger.debug(ServiceHandler.createLogMessage(message, response));
        }
        return isXhr ? response : ServiceHandler.parseResponse(response);
    };
    ServiceHandler.handleErrorRes = function (e, xhr, response, message) {
        if (csod.context.log.level !== 'off') {
            csod.logger.error(ServiceHandler.createLogMessage(message, xhr));
        }
        if (xhr.status === 401 && csod.notify && csod.notify.error) {
            csod.notify.error(csod.locales.get('CORE.http.genericError', 'Something went wrong. Please refresh the page and try again'));
        }
        return Promise.reject([e, xhr, response]);
    };
    ServiceHandler.roughSizeOfObject = function (object) {
        var objectList = [];
        var stack = [object];
        var bytes = 0;
        while (stack.length) {
            var value = stack.pop();
            if (typeof value === 'boolean') {
                bytes += 4;
            }
            else if (typeof value === 'string') {
                bytes += value.length * 2;
            }
            else if (typeof value === 'number') {
                bytes += 8;
            }
            else if (typeof value === 'object'
                && objectList.indexOf(value) === -1) {
                objectList.push(value);
                for (var i in value) {
                    stack.push(value[i]);
                }
            }
        }
        return bytes;
    };
    ServiceHandler.setAuthHeader = function (options) {
        if (csod.context.env !== 'development') {
            if (options) {
                if (options.headers) {
                    options.headers['Authorization'] = 'Bearer ' + csod.context.token;
                    options.headers['CSOD-Accept-Language'] = csod.context.cultureName;
                }
                else {
                    options.headers = {
                        Authorization: 'Bearer ' + csod.context.token,
                        'CSOD-Accept-Language': csod.context.cultureName
                    };
                }
            }
            else {
                options = {
                    headers: {
                        Authorization: 'Bearer ' + csod.context.token,
                        'CSOD-Accept-Language': csod.context.cultureName
                    }
                };
            }
            if (Utilities_1.IE) {
                options.headers['Pragma'] = 'no-cache';
            }
        }
        return options;
    };
    ServiceHandler.getHeaderMap = function (headers) {
        if (!headers)
            return {};
        var data = headers.trim().split(/[\r\n]+/);
        return data.reduce(function (acc, curr) {
            var _a = curr.split(/[:]\s?(.+)/), key = _a[0], val = _a[1];
            acc[key.toLowerCase()] = val;
            return acc;
        }, {});
    };
    ServiceHandler.createLogMessage = function (message, xhr) {
        if (xhr && xhr.getAllResponseHeaders()) {
            var _a = ServiceHandler.getHeaderMap(xhr.getAllResponseHeaders()), correlationID = _a["x-csod-correlation-id"], contentLength = _a["content-length"];
            if (correlationID)
                message.data.serviceContextID = correlationID;
            message.data.size = contentLength || ServiceHandler.roughSizeOfObject(xhr.response);
            if (xhr)
                message.data.xhr = {
                    readyState: xhr.readyState,
                    responseType: xhr.responseType,
                    responseURL: xhr.responseURL,
                    status: xhr.status,
                    statusText: xhr.statusText,
                    timeout: xhr.timeout
                };
        }
        message.state = Logger_1.XHRTraceMessageState.End;
        return message;
    };
    return ServiceHandler;
}());
exports.ServiceHandler = ServiceHandler;
var _legacyHandler = new ServiceHandler('');
var ServiceEndpointHandler = (function (_super) {
    __extends(ServiceEndpointHandler, _super);
    function ServiceEndpointHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceEndpointHandler.prototype.initialize = function (apiBase, cloudBase) {
        this.api = new ServiceHandler(apiBase);
        this.cloud = new ServiceHandler(cloudBase);
    };
    ServiceEndpointHandler.prototype.setDefaultOptions = function (options) {
        qwest.setDefaultOptions(options);
    };
    ServiceEndpointHandler.prototype.get = function (url, options, isXhr, before) {
        return _legacyHandler.get(url, options, isXhr, before);
    };
    ServiceEndpointHandler.prototype.post = function (url, data, options, isXhr, before) {
        return _legacyHandler.post(url, data, options, isXhr, before);
    };
    ServiceEndpointHandler.prototype.put = function (url, data, options, isXhr, before) {
        return _legacyHandler.put(url, data, options, isXhr, before);
    };
    ServiceEndpointHandler.prototype.delete = function (url, options, isXhr, before) {
        return _legacyHandler.delete(url, options, isXhr, before);
    };
    ServiceEndpointHandler.prototype.batchDelete = function (url, data, options, isXhr, before) {
        return _legacyHandler.batchDelete(url, data, options, isXhr, before);
    };
    ServiceEndpointHandler.prototype.patch = function (url, data, options, isXhr, before) {
        return _legacyHandler.patch(url, data, options, isXhr, before);
    };
    return ServiceEndpointHandler;
}(Utilities_1.ServiceEndpoint));
exports.ServiceEndpointHandler = ServiceEndpointHandler;



//////////////////
// WEBPACK FOOTER
// ./src/Utilities/Service.ts
// module id = 69
// module chunks = 0